import { LetterTaskResponse } from './types';
import { get, postJson } from "../../../hook/request";
import type { AxiosResponse } from "axios";
import { LetterBoxFilters } from "../context/FilterContext";
import { letterBoxListResult, LetterBoxListApiResponse, SimpleStatusResponse, LetterDetailResponse, SendMailPayload, LetterTaskPayload } from "./types";

export async function getTaskList(filters: LetterBoxFilters): Promise<letterBoxListResult> {
  const params: Record<string, string | number> = { filter: filters.status };
  if (filters.selectNumber !== undefined) params.selectNumber = filters.selectNumber;
  if (filters.search) params.search = filters.search;
  if (filters.new === 1) params.new = 1;

  const res: AxiosResponse<LetterBoxListApiResponse> = await get("/letterBox/list", params);
  const data = res.data;
  const value = data.values;

  if (data.status && data.status !== "ok") {
    return {
      list: [],
      n_pages: 0,
      actives: 0,
      deleted: 0,
      favourite: 0,
    };
  }


  return {
    list: data.list,
    n_pages: data.n_pages,
    actives: value.actives,
    deleted: value.deleted,
    favourite: value.favourite,
  };
}

export async function toggleFavouriteEmail(id: number, isFavourite: boolean): Promise<SimpleStatusResponse> {
  const endpoint = isFavourite ? `/letterBox/not_favourite?ID=${id}` : `/letterBox/favourite?ID=${id}`;
  const res: AxiosResponse<SimpleStatusResponse> = await postJson(endpoint);
  return res.data ?? { status: "ok" };
}

export async function reloadLetterBox(): Promise<SimpleStatusResponse> {
  const res: AxiosResponse<SimpleStatusResponse> = await postJson("/letterBox/reload");
  return res.data ?? { status: "ok" };
}

export async function readAllLetters(): Promise<SimpleStatusResponse> {
  const res: AxiosResponse<SimpleStatusResponse> = await postJson('/letterBox/read_all');
  if (res.data?.status === 'error') throw new Error(res.data.message || 'Impossibile segnare le email come lette.');
  return res.data ?? { status: 'ok' };
}

export async function deleteLetters(ids: number[]): Promise<SimpleStatusResponse> {
  const res: AxiosResponse<SimpleStatusResponse> = await postJson("/letterBox/delete", { ids });
  return res.data ?? { status: "ok" };
}

export async function getLetterDetails(id: string | number): Promise<LetterDetailResponse> {
  const res: AxiosResponse<LetterDetailResponse> = await get(`/letterBox/datails?ID=${id}`);
  return res.data;
}

export async function sendReply(id: number, text: string): Promise<SimpleStatusResponse> {
  const endpoint =`/letterBox/reply?ID=${id}`;
  const res: AxiosResponse<SimpleStatusResponse> = await postJson(endpoint, text);
  return res.data ?? { status: "ok" };
}


export async function sendMail(payload: SendMailPayload): Promise<SimpleStatusResponse> {
  const res: AxiosResponse<SimpleStatusResponse> = await postJson("/letterBox/send", payload);
  return res.data ?? { status: "ok" };
}

export async function createLetterTask(endpoint: string, payload: LetterTaskPayload): Promise<LetterTaskResponse> {
  const res: AxiosResponse<LetterTaskResponse> = await postJson(endpoint, payload);
  if (res.data?.status === "error") throw new Error(res.data.message || "Errore durante la creazione del task.");
  return res.data;
}
export async function addLetterComment(payload: { ID: number; progetto_id: number; descrizione: string }): Promise<SimpleStatusResponse> {
  const res: AxiosResponse<SimpleStatusResponse> = await postJson('/letterBox/addComment', payload);
  if (res.data?.status === 'error') throw new Error(res.data.message || 'Errore durante aggiunta nota.');
  return res.data;
}

export async function addClienteEmail(payload: { email: string; clienteID: number }): Promise<SimpleStatusResponse> {
  const res: AxiosResponse<SimpleStatusResponse> = await postJson('/letterBox/addClienteEmail', payload);
  if (res.data?.status === 'error') throw new Error(res.data.message || 'Impossibile associare il cliente all’email.');
  return res.data ?? { status: 'ok' };
}

export async function replyLetterEmail(payload: { EmailID: number; ID: number; progetto_id: number; descrizione: string }): Promise<SimpleStatusResponse> {
  const res: AxiosResponse<SimpleStatusResponse> = await postJson('/letterBox/replyEmail', payload);
  if (res.data?.status === 'error') throw new Error(res.data.message || 'Errore durante invio risposta.');
  return res.data;
}
